module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Size 大小")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<button class=\"button small\">Small</button>\n<button class=\"button\">Default</button>\n<button class=\"button large\">Large</button>\n<button class=\"button large\" disabled>Disabled</button>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Color 颜色")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', [_vm._v("<button class=\"button primary\">Primary</button>\n<button class=\"button success\">Success</button>\n<button class=\"button info\">Info</button>\n<button class=\"button danger\">Danger</button>\n<button class=\"button warning\">Warning</button>\n<button class=\"button link\">Link</button>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Shape 形状")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(2), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<button class=\"square-button mini\">m</button>\n<button class=\"square-button small\">S</button>\n<button class=\"square-button\">D</button>\n<button class=\"square-button large\">L</button>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<button class=\"cycle-button mini\">m</button>\n<button class=\"cycle-button small\">S</button>\n<button class=\"cycle-button\">D</button>\n<button class=\"cycle-button large\">L</button>\n")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Icon-button 带Icon的按钮  (Font-awesome)")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<button class=\"button large info\">\n  <i class=\"fa fa-commenting\"></i> Comment</button>\n<button class=\"button large primary\">\n  <i class=\"fa fa-check\"></i> Submit</button>\n<button class=\"button large danger\">\n  <i class=\"fa fa-remove\"></i> Cancel</button>")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Outline-button 线形按钮")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<button class=\"button primary outline\">primary</button>\n<button class=\"button success outline\">success</button>\n<button class=\"button info outline\">info</button>\n<button class=\"button warning outline\">warning</button>\n<button class=\"button danger outline\">danger</button>")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Button-group 按钮组")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(6), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"btn-group\">\n  <button class=\"button\">One</button>\n  <button class=\"button\">Two</button>\n  <button class=\"button\">Three</button>\n</div>")])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"btn-group\">\n  <button class=\"square-button primary outline\">\n    <i class=\"fa fa-plus\"></i>\n  </button>\n  <button class=\"square-button primary outline\">\n    <i class=\"fa fa-pencil\"></i>\n  </button>\n  <button class=\"square-button primary outline\">\n    <i class=\"fa fa-download\"></i>\n  </button>\n</div>")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('button', {
    staticClass: "button small"
  }, [_vm._v("Small")]), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_vm._v("Default")]), _vm._v(" "), _c('button', {
    staticClass: "button large"
  }, [_vm._v("Large")]), _vm._v(" "), _c('button', {
    staticClass: "button large",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('button', {
    staticClass: "button primary"
  }, [_vm._v("Primary")]), _vm._v(" "), _c('button', {
    staticClass: "button success"
  }, [_vm._v("Success")]), _vm._v(" "), _c('button', {
    staticClass: "button info"
  }, [_vm._v("Info")]), _vm._v(" "), _c('button', {
    staticClass: "button danger"
  }, [_vm._v("Danger")]), _vm._v(" "), _c('button', {
    staticClass: "button warning"
  }, [_vm._v("Warning")]), _vm._v(" "), _c('button', {
    staticClass: "button link"
  }, [_vm._v("Link")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "square-button mini"
  }, [_vm._v("m")]), _vm._v(" "), _c('button', {
    staticClass: "square-button small"
  }, [_vm._v("S")]), _vm._v(" "), _c('button', {
    staticClass: "square-button"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "square-button large"
  }, [_vm._v("L")]), _vm._v(" "), _c('button', {
    staticClass: "square-button primary"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "square-button info"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "square-button danger"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "square-button warning"
  }, [_vm._v("D")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "cycle-button mini"
  }, [_vm._v("m")]), _vm._v(" "), _c('button', {
    staticClass: "cycle-button small"
  }, [_vm._v("S")]), _vm._v(" "), _c('button', {
    staticClass: "cycle-button"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "cycle-button large"
  }, [_vm._v("L")]), _vm._v(" "), _c('button', {
    staticClass: "cycle-button primary"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "cycle-button info"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "cycle-button danger"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "cycle-button warning"
  }, [_vm._v("D")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('button', {
    staticClass: "button large info"
  }, [_c('i', {
    staticClass: "fa fa-commenting"
  }), _vm._v(" Comment")]), _vm._v(" "), _c('button', {
    staticClass: "button large primary"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button large danger"
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Cancel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "box"
  }, [_c('button', {
    staticClass: "button primary outline"
  }, [_vm._v("primary")]), _vm._v(" "), _c('button', {
    staticClass: "button success outline"
  }, [_vm._v("success")]), _vm._v(" "), _c('button', {
    staticClass: "button info outline"
  }, [_vm._v("info")]), _vm._v(" "), _c('button', {
    staticClass: "button warning outline"
  }, [_vm._v("warning")]), _vm._v(" "), _c('button', {
    staticClass: "button danger outline"
  }, [_vm._v("danger")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("One")]), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_vm._v("Two")]), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_vm._v("Three")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "square-button primary outline"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button primary outline"
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button primary outline"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a29fc9f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/button.vue
// module id = 407
// module chunks = 1